<app-left-side-nav></app-left-side-nav>
<app-header></app-header>

<!-- page content area start -->
 <ng-container *ngIf="!isInitializing; else loadingTemplate">
	<div class="afterLoginPageContainer" *ngIf="!isZeroAssignedTickets">
	<div class="mainContent">
		<div class="paid_order_summary">
			<div class="px-3 py-2 d-flex justify-content-between align-items-center">
				<div class="backLink" (click)="goBack()">
					<i class="fa fa-chevron-left me-3" ></i> My Tickets
				</div>
			</div>

			<!--
				Displays a ticket section if there are unassigned tickets.
				The section uses Bootstrap flex utilities to align and space its contents.
				- *ngIf="unassignedTickets > 0": Shows the div only when there are unassigned tickets.
				- class="myTkt d-flex align-items-center justify-content-between": Applies custom and Bootstrap classes for styling and layout.
			-->
			<div *ngIf="unassignedTickets > 0 && (eventDetails?.allow_to_register === 1 && eventDetails?.event_status !== 'over')" class="myTkt d-flex align-items-center justify-content-between mb-4">
				<p class="mb-0">You have not filled {{ unassignedTickets }} ticket <span
						*ngIf="unassignedTickets > 1">forms</span><span *ngIf="unassignedTickets === 1">form</span></p>
				<a class="myTktBtn" (click)="assignTickets()">Fill <span *ngIf="unassignedTickets > 1">Forms</span><span *ngIf="unassignedTickets === 1">Form</span></a>
			</div>


			<!--
				Displays a success message when tickets are assigned successfully.
				- Visible only if 'assignedSuccess' is true.
				- Styled with a green background and padding.
				- Message prompts user to tap for detailed ticket information.
			-->
			<div *ngIf="assignedSuccess && ticketList.length > 0" class="myTkt d-flex align-items-center justify-content-between mb-4"
				[ngStyle]="{ 'background-color': '#28A938', padding: '18px 15px 12px' }">
				<p class="mb-0">
					Tickets assigned successfully. Tap to see detailed ticket
				</p>
			</div>

			<!-- Start No Tickets section -->
			<div *ngIf="ticketList.length === 0 && !isLoading" class="noTicket text-center align-items-center">
				<img class="my-4" src="/assets/images/bulk-ticket.png" />
				<p>
					You do not have any tickets for KISAN.<br />
					All your tickets will be listed here.
				</p>
				<p>Buy some tickets now.</p>
			</div>
			<!-- End No Tickets section -->

			<!-- Start My Tickets Section -->
			<div *ngFor="let ticket of ticketList">
				<div class="ticketList m-3">
					<div class="ticketA" (click)="openTicketDetails(ticket.encoded_ticket_code)">
						<div class="tktType ticket p-0 mb-3" [ngStyle]="{
								background: ticketTypeColor[ticket.ticket_type_code].colorGradientBackground
							}">
							<div class="wrapper">
								<div class="d-flex justify-content-end pt-2">
									<div class="selTktType d-flex justify-content-center mt-1">
										<img class="leafImg" [src]="ticketTypeLogo[ticket.ticket_type_code].color" />
										<span [ngStyle]="{ color: ticketTypeColor[ticket.ticket_type_code].primary }" translate="no">{{
											ticket.ticket_type_name }}</span>
									</div>
								</div>
								<div class="d-flex justify-content-between align-items-end usInf">
									<div class="mainInfo">
										<div class="d-flex align-items-center personInfo">
											<div class="photoWrap">
												<img [src]="ticket.image_url"
													onerror="this.src='/assets/images/default-profile-individual.png'" />
											</div>

											<div class="profileDetails ml-2">
												<h6 class="text-white fwbold text-capitalize" translate="no">
													{{ ticket.first_name }} {{ ticket.last_name }}
												</h6>
												<h6 class="text-white mb-0" translate="no">
													{{ getMobileNo(ticket.mobile) }} |
													<span class="state_code"></span>{{ ticket.city }}, {{
													ticket.state
													}}
												</h6>
											</div>
										</div>
										<div class="info py-2">
											<ul class="mb-0">
												<li>{{ ticketNote[ticket.ticket_type_code].ticketNote?.line1 }}</li>
												<li>{{ ticketNote[ticket.ticket_type_code].ticketNote?.line2 }}</li>
											</ul>
										</div>
									</div>
									<div class="qrWrapper mb-3">
										<!-- <div class="box"><img src="/assets/images/unloack.png"></div> -->
										<div class="lockSec">
											<img class="mb-2" src="/assets/images/view_qr.gif" width="24" height="31"
												style="rotate: -15deg" />
											View QR
										</div>
									</div>
								</div>
								<div class="foot" [ngStyle]="{
										'background-color': ticketTypeColor[ticket.ticket_type_code]
											.darkPrimary
									}">
									Tap to see a detailed ticket
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="catalogWrapper m-3" *ngIf="eventDetails?.show_digital_catalog" (click)="goToDigitalCatalogue()">
				<img src="/assets/images/go_to_digital_catlog.png" alt="Go To Digital Catalogue" />
		    </div>
			<div class="hgt"></div>
			<div *ngIf="ticketList.length > 0 && (eventDetails?.allow_to_register === 1 && eventDetails?.event_status !== 'over')" class="footBtn" (click)="buyTickets()">
				<a class="bookMore d-flex align-items-center">
					<h6 class="mb-0">
						Buy More Tickets
					</h6>
				</a>
			</div>

			<div *ngIf="(ticketList.length === 0 && !isLoading) && (eventDetails?.allow_to_register === 1 && eventDetails?.event_status !== 'over')" class="footBtn" (click)="buyTickets()">
				<a class="buyTickets d-flex align-items-center">
					<h6 class="mb-0">Buy Tickets
					</h6>
				</a>
			</div>


			<!-- End My Tickets Section -->
		</div>
	</div>
	
</div>

 </ng-container>
<ng-template #loadingTemplate>
  <div class="loader-container">
	<app-loader></app-loader>
  </div>
</ng-template>

<app-support-button [phone]="supportPhone"></app-support-button>
